import { LanguagesType } from "../src/apop/common/LanguageCard/Language.types";
import { DropdownOptionType } from "../types";

export const ExperienceYearsDropdownOptionsData: DropdownOptionType[] = [
  {
    id: 0,
    text: "0 year",
  },
  {
    id: 1,
    text: "1 year",
  },
  {
    id: 2,
    text: "2 years",
  },
  {
    id: 3,
    text: "3 years",
  },
  {
    id: 4,
    text: "4 years",
  },
  {
    id: 5,
    text: "5 years",
  },
  {
    id: 6,
    text: "6 years",
  },
  {
    id: 7,
    text: "7 years",
  },
  {
    id: 8,
    text: "8 years",
  },
  {
    id: 9,
    text: "9 years",
  },
  {
    id: 10,
    text: "10 years",
  },
  {
    id: 11,
    text: "11 years",
  },
  {
    id: 12,
    text: "12 years",
  },
  {
    id: 13,
    text: "13 years",
  },
  {
    id: 14,
    text: "14 years",
  },
  {
    id: 15,
    text: "15 years",
  },
  {
    id: 16,
    text: "16 years",
  },
  {
    id: 17,
    text: "17 years",
  },
  {
    id: 18,
    text: "18 years",
  },
  {
    id: 19,
    text: "19 years",
  },
  {
    id: 20,
    text: "20 years",
  },
  {
    id: 21,
    text: "21 years",
  },
  {
    id: 22,
    text: "22 years",
  },
  {
    id: 23,
    text: "23 years",
  },
  {
    id: 24,
    text: "24 years",
  },
  {
    id: 25,
    text: "25 years",
  },
  {
    id: 26,
    text: "26 years",
  },
  {
    id: 27,
    text: "27 years",
  },
  {
    id: 28,
    text: "28 years",
  },
  {
    id: 29,
    text: "29 years",
  },
  {
    id: 30,
    text: "30 years",
  },
  {
    id: 31,
    text: "31 years",
  },
  {
    id: 32,
    text: "32 years",
  },
  {
    id: 33,
    text: "33 years",
  },
  {
    id: 34,
    text: "34 years",
  },
  {
    id: 35,
    text: "35 years",
  },
  {
    id: 36,
    text: "36 years",
  },
  {
    id: 37,
    text: "37 years",
  },
  {
    id: 38,
    text: "38 years",
  },
  {
    id: 39,
    text: "39 years",
  },
  {
    id: 40,
    text: "40 years",
  },
  {
    id: 41,
    text: "41 years",
  },
  {
    id: 42,
    text: "42 years",
  },
  {
    id: 43,
    text: "43 years",
  },
  {
    id: 44,
    text: "44 years",
  },
  {
    id: 45,
    text: "45 years",
  },
  {
    id: 46,
    text: "46 years",
  },
  {
    id: 47,
    text: "47 years",
  },
  {
    id: 48,
    text: "48 years",
  },
  {
    id: 49,
    text: "49 years",
  },
  {
    id: 50,
    text: "50 years",
  },
];

export const ExperienceMonthsDropdownOptionsData: DropdownOptionType[] = [
  {
    id: 0,
    text: "0 month",
  },
  {
    id: 1,
    text: "1 month",
  },
  {
    id: 2,
    text: "2 months",
  },
  {
    id: 3,
    text: "3 months",
  },
  {
    id: 4,
    text: "4 months",
  },
  {
    id: 5,
    text: "5 months",
  },
  {
    id: 6,
    text: "6 months",
  },
  {
    id: 7,
    text: "7 months",
  },
  {
    id: 8,
    text: "8 months",
  },
  {
    id: 9,
    text: "9 months",
  },
  {
    id: 10,
    text: "10 months",
  },
  {
    id: 11,
    text: "11 months",
  },
  {
    id: 12,
    text: "12 months",
  },
];

export const GenderDropdownOptionsData: DropdownOptionType[] = [
  {
    id: "bd5a224c-fc69-11e8-92d8-000c290b6677",
    text: "Male",
  },
  {
    id: "ccc7faa0-fc69-11e8-92d8-000c290b6677",
    text: "Female",
  },
  {
    id: "c7f21630-2480-11e9-aabd-70106fbef856",
    text: "Prefer not to say",
  },
];

export const WorkAuthorizationDropdownOptionsData = (site_map?: string) => {
  if (site_map && site_map === "monstergulf") {
    return [
      {
        id: "",
        text: "I don't have work authorization",
      },
      { id: "b49608da-24cd-11e9-bde9-1418775c7275", text: "Visit Visa" },
      {
        id: "b5110f8f-24cd-11e9-bde9-1418775c7275",
        text: "Employment Visa (Noc attached)",
      },
      {
        id: "b5708d07-24cd-11e9-bde9-1418775c7275",
        text: "Employment Visa (Noc not attached)",
      },
      {
        id: "b5b8a948-24cd-11e9-bde9-1418775c7275",
        text: "Employment Visa Free Zone",
      },
      {
        id: "b603169b-24cd-11e9-bde9-1418775c7275",
        text: "Dependent Visa (Husband/Father)",
      },
      { id: "b648f572-24cd-11e9-bde9-1418775c7275", text: "Investors Visa" },
      {
        id: "96da092f-9f4b-11ea-9839-3ca82aea620e",
        text: "Transferable Iquama",
      },
      {
        id: "53988ac4-b487-11ea-bb0f-000c29abc036",
        text: "I have Permanent Residency",
      },
      {
        id: "5399134f-b487-11ea-bb0f-000c29abc036",
        text: "I have work authorization",
      },
    ];
  }

  return [
    {
      id: "",
      text: "I don't have work authorization",
    },
    {
      id: "5399134f-b487-11ea-bb0f-000c29abc036",
      text: "I have work authorization",
    },
    {
      id: "53988ac4-b487-11ea-bb0f-000c29abc036",
      text: "I have Permanent Residency",
    },
  ];
};

export const LanguageCheckBoxOptionsData = [
  {
    value: "read",
    id: "read",
    displayName: "Read",
  },
  {
    value: "write",
    id: "write",
    displayName: "Write",
  },
  {
    value: "speak",
    id: "speak",
    displayName: "Speak",
  },
];

export const DefaultLanguageData: LanguagesType = {
  read: 0,
  write: 0,
  speak: 0,
  language: null,
  proficiency: null,
};
